module.exports = __webpack_public_path__ + "static/front1-398d8c36212af56fbee956bd63147292.jpg";